export const USER_MODE = {
  SHOP_ADMIN: 'shop-admin',
  CUSTOMER: 'customer'
};
